export default __webpack_public_path__ + "media/titles/title_6_locale_tr-1f858e1d.png";